module.exports = __webpack_public_path__ + "img/Josip.b8814237.png";